@if (segments.length || attachmentSummaries.length) {
  <div [ngStyle]="getProductCardStyleVars()" class="conversation-transcript">
    @if (message?.user && attachmentSummaries.length) {
      <div aria-label="Uploaded files" class="conversation-attachment-list">
        @for (attachment of attachmentSummaries; track trackAttachment($index, attachment)) {
          <div class="conversation-attachment-chip">
            @if (attachment.attachmentId && canPreviewAttachment(attachment)) {
              @if (attachmentUrls[attachment.attachmentId]; as imageUrl) {
                <a [href]="imageUrl" [download]="getAttachmentDisplayName(attachment, $index)">
                  <img [src]="imageUrl" [alt]="getAttachmentDisplayName(attachment, $index)" class="conversation-attachment-preview">
                  Download image
                </a>
              } @else {
                <button type="button" (click)="previewAttachment(attachment)"
                        [disabled]="attachmentStates[attachment.attachmentId] === 'loading'">Preview image</button>
              }
              @if (attachmentStates[attachment.attachmentId] && !['loading', 'ready'].includes(attachmentStates[attachment.attachmentId])) {
                <span role="status">{{ attachmentStates[attachment.attachmentId] }}</span>
              }
            }
            <span [title]="getAttachmentDisplayName(attachment, $index)"
                  class="conversation-attachment-chip__name">
              {{ getAttachmentDisplayName(attachment, $index) }}
            </span>
            @if (getAttachmentMetaText(attachment); as metaText) {
              <span class="conversation-attachment-chip__meta">{{ metaText }}</span>
            }
          </div>
        }
      </div>
    }
    @for (segment of segments; track trackSegment($index, segment)) {
      @if (segment.kind === 'text') {
        @if (isUserMessage()) {
          <div [ngClass]="getTextSegmentClasses()" class="conversation-transcript-text">{{ segment.text }}</div>
        } @else {
          <div [innerHTML]="getMarkdownText(segment.text)"
               [ngClass]="getTextSegmentClasses()"
               class="conversation-transcript-text"></div>
        }
      } @else {
        <div class="conversation-product-card-groups">
          <div [class.conversation-product-card-group--carousel]="isCarouselGroup(segment)"
               [class.conversation-product-card-group--vertical-list]="isVerticalListGroup(segment)"
               class="conversation-product-card-group">
            @for (card of segment.cards; track trackCard($index, card)) {
              <a [class.conversation-product-card--vertical]="isCarouselGroup(segment)"
                 [class.conversation-product-card--list]="isVerticalListGroup(segment)"
                 [href]="card.url"
                 class="conversation-product-card"
                 rel="noopener noreferrer"
                 target="_blank">
                <div class="conversation-product-card__image">
                  @if (shouldShowProductCardImage(card)) {
                    <img (error)="onProductCardImageError(card)" [alt]="card.name" [src]="card.imageUrl">
                  } @else {
                    <span>{{ card.name }}</span>
                  }
                </div>
                <div class="conversation-product-card__body">
                  <div class="conversation-product-card__title">{{ card.name }}</div>
                  @if (shouldShowProductCardPrice()) {
                    @if (getProductCardPrice(card); as price) {
                      <div [class.conversation-product-card__price--sale]="isSalePrice(price)"
                           class="conversation-product-card__price">
                        <span class="conversation-product-card__price-current">{{ price.current }}</span>
                        @if (price.original) {
                          <span class="conversation-product-card__price-original">Før {{ price.original }}</span>
                        }
                      </div>
                    }
                  }
                  @if (shouldShowProductCardDescription() && card.description) {
                    <div class="conversation-product-card__description">{{ card.description }}</div>
                  }
                  <span class="conversation-product-card__button">Se detaljer</span>
                </div>
              </a>
            }
          </div>
        </div>
      }
    }
  </div>
}
